/**
 * Generated by orval 🍺
 * Do not edit manually.
 * GTA CRM Demo API
 * GTA CRM 生产级 demo 的只读+轻写 API(feat-008;demo-scoped,零 model 零迁移)。
 * OpenAPI spec version: 1.0.0
 */

/**
 * * `not_started` - 未开始
 * * `ready` - 待出行
 * * `traveling` - 出行中
 * * `returned` - 已回程
 */
export type WonReceiptTravelStatusEnum =
  (typeof WonReceiptTravelStatusEnum)[keyof typeof WonReceiptTravelStatusEnum];

export const WonReceiptTravelStatusEnum = {
  not_started: "not_started",
  ready: "ready",
  traveling: "traveling",
  returned: "returned",
} as const;
